import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import DepotDetail from "@/pages/DepotDetail";
import TowerDetail from "@/pages/TowerDetail";
import TakedownPolicy from "@/pages/TakedownPolicy";
import States from "@/pages/States";
import StateDepots from "@/pages/StateDepots";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Submit from "@/pages/Submit";
import SubmitEdit from "@/pages/SubmitEdit";
import Contributors from "@/pages/Contributors";
import TripPlanner from "@/pages/TripPlanner";
import { TripTray } from "@/components/TripTray";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/depot/:id" element={<DepotDetail />} />
      <Route path="/tower/:id" element={<TowerDetail />} />
      <Route path="/legal/takedown" element={<TakedownPolicy />} />
      <Route path="/legal/copyright" element={<TakedownPolicy />} />
      <Route path="/states" element={<States />} />
      <Route path="/states/:stateCode" element={<StateDepots />} />
      <Route path="/about" element={<About />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/submit" element={<Submit />} />
      <Route path="/depot/:id/edit" element={<SubmitEdit />} />
      <Route path="/contributors" element={<Contributors />} />
      <Route path="/trip-planner" element={<TripPlanner />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0a0a0a]">
      <ErrorBoundary>
        <BrowserRouter>
          <AppRouter />
          <TripTray />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </ErrorBoundary>
    </div>
  );
}

export default App;
